<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <div>
      <!-- dialog common header -->
      <popup-header v-on:clickClose="closeModal()"></popup-header>
      <!-- 제목 -->
      <v-row class="title-wrap">
        <v-col cols="12" class="icon-title word-type big-title big-padding"
          ><icon-work-day></icon-work-day>{{ detailObjProps.dayTitle }}</v-col
        >
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" class="px-6 py-0">
          <v-card elevation="0" class="work-time">
            <v-row class="ma-0">
              <!-- 출근시간 -->
              <v-col cols="6" class="py-0 pl-0 pr-9 text-center">
                <div class="label">
                  <v-icon size="18">mdi-clipboard-account-outline</v-icon>
                  출근시간
                </div>
                <div class="time">{{ getInTime }}</div>
              </v-col>
              <!-- 퇴근시간 -->
              <v-col cols="6" class="py-0 pr-0 pl-9 divider text-center">
                <div class="label">
                  <v-icon size="18">mdi-alarm</v-icon>
                  퇴근시간
                </div>
                <div class="time">{{ getOutTime }}</div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- 근태현황 -->
        <v-col cols="12" class="borderLine-outer pt10">
          <div class="borderLine-wrap d-flex justify-space-between py-5">
            <span class="label">근태현황</span>
            <ul class="d-inline borderLine-title">
              <li
                v-for="item in detailObjProps.dailyEventList"
                :key="item.applSeq"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </v-col>
      </v-row>
      <bottom-btn
        v-if="applBtnFlag"
        v-on:goApplMenuList="goApplMenuList"
      ></bottom-btn>
    </div>
  </v-dialog>
</template>

<script>
/* 일정상세 모달 */
import PopupHeader from '@/components/common/PopupHeader.vue';
import IconWorkDay from '@/assets/customIcon/IconWorkDay.vue';
import BottomBtn from '@/components/common/BottomBtn.vue';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **

export default {
  mixins: [dialogMixin],

  props: {
    detailObjProps: {
      type: Object,
    },
    applBtnFlag: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    modalName: 'calendar_detail',
  }),
  computed: {
    getInTime() {
      let inOutTime = this.detailObjProps.dailyInOutTime;
      if (this.$store.getters.GET_USER_DATA.ssnStatusCd!=='CA') {
        if (inOutTime != undefined) {
          return inOutTime.split('퇴')[0];
        }
      }

      return '--:--';
    },
    getOutTime() {
      let inOutTime = this.detailObjProps.dailyInOutTime;
      if (this.$store.getters.GET_USER_DATA.ssnStatusCd!=='CA') {
        if (inOutTime != undefined) {
          return inOutTime.split('퇴')[1];
        }
      }
      return '--:--';
    },
  },
  methods: {
    goApplMenuList() {
      this.$emit('goApplMenuList');
    },
  },
  components: {
    PopupHeader,
    IconWorkDay,
    BottomBtn,
  },
};
</script>

<style>
/* _calendarDetail.scss */
</style>
